import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import utc from 'dayjs/plugin/utc';
import allCountries from './countries.v1.json';
import { BONUS_TRANSACTION_TYPE, Country } from '../types';
import { t } from 'i18next';
import project from 'src/config/project.json';
import liveCard from 'src/assets/sidebar-icons/live-card.png';
import cup from 'src/assets/sidebar-icons/cup.png';
import jackpots from 'src/assets/sidebar-icons/sidebarJackpots.png';
import gift from 'src/assets/sidebar-icons/gift.png';
import star from 'src/assets/sidebar-icons/star.png';
import diamondSidebar from 'src/assets/sidebar-icons/diamondSidebar.png';
import shopChest from 'src/assets/sidebar-icons/shopChest.png';
import { Link } from 'react-router';
import { License } from 'src/components/svg/License';
import lnld from '../assets/images/lnld.webp';
import 'src/components/Games/GamesControlPanel/styles.css';
import { Tooltips } from 'src/components/Sidebar/components/SidebarTooltip';
import {
  Astropay,
  BankTransfer,
  Bitcoin,
  Cashtocode,
  EcoPayz,
  Ethereum,
  Ezeewallet,
  Flexepin,
  Interac,
  Jeton,
  Litecoin,
  MB,
  Neosurf,
  Neteller,
  Paysafe,
  Ripple,
  Skrill,
  Tether
} from 'src/components/svg/Payments';
import { isProductionEnv } from 'src/api';
import { RoutesType } from 'src/router/hooks';

export enum GameCardBannerType {
  TOP = 'TOP',
  BONUS = 'BONUS',
  NEW = 'NEW',
  LIVE = 'LIVE'
}

export const SIGN_UP_BONUS_ID = isProductionEnv ? '163' : '137';

export const bonusHeader = [
  'transactionsTable.date',
  'transactionsTable.gameName',
  'transactionsTable.amount',
  'transactionsTable.balance',
  'transactionsTable.status'
];
export const basicHeader = [
  'transactionsTable.date',
  'transactionsTable.gameName',
  'transactionsTable.amount',
  'transactionsTable.balance',
  'transactionsTable.status'
];
export const transactionHistoryHeader = [
  'transactionHistoryTable.date',
  'transactionHistoryTable.amount',
  'transactionHistoryTable.fee',
  'transactionHistoryTable.curerncy',
  'transactionHistoryTable.status'
];

type MenuItemType = {
  path: RoutesType;
  name: string;
  image: JSX.Element;
  tooltipId: string;
  tooltip: Tooltips;
};

export const menuItem: MenuItemType[] = [
  {
    path: 'GAMES',
    name: 'menuItem.games',
    image: <img src={diamondSidebar} alt="diamond Sidebar" className="max-w-5" />,
    tooltipId: 'sidebar-top-games',
    tooltip: Tooltips.GAMES
  },
  {
    path: 'SHOP',
    name: 'menuItem.shop',
    image: <img src={shopChest} alt="shop Chest" className="max-w-5" />,
    tooltipId: 'sidebar-shop',
    tooltip: Tooltips.SHOP
  },
  {
    path: 'GAMES_LIVE',
    name: 'menuItem.live',
    image: <img src={liveCard} alt="liveCard" className="max-w-5" />,
    tooltipId: 'sidebar-live',
    tooltip: Tooltips.LIVE
  },
  // {
  //   path: '/halloween',
  //   name: 'menuItem.halloweenSpins',
  //   image: <img src={zombieFaceIcon} alt="halloween" className="max-w-5" />,
  //   tooltipId: 'sidebar-halloween',
  //   tooltip: Tooltips.HALLOWEEN
  // },
  {
    path: 'BONUSES',
    name: 'menuItem.bonuses',
    image: <img src={gift} alt="gift" className="max-w-5" />,
    tooltipId: 'sidebar-promo',
    tooltip: Tooltips.PROMO
  },
  {
    path: 'JACKPOTS',
    name: 'profileMenuItems.jackpots',
    image: <img src={jackpots} alt="jackpots" className="max-w-5" />,
    tooltipId: 'sidebar-jackpots',
    tooltip: Tooltips.JACKPOTS
  },
  {
    path: 'TOURNAMENTS',
    name: 'menuItem.tournaments',
    image: <img src={cup} alt="cup" className="max-w-5" />,
    tooltipId: 'sidebar-tournaments',
    tooltip: Tooltips.TOURNAMENTS
  },
  {
    path: 'ALL_ROUTES',
    name: 'menuItem.dailyBonus',
    image: <></>,
    tooltipId: 'sidebar-daily-bonus',
    tooltip: Tooltips.TOURNAMENTS
  },
  {
    path: 'ALL_ROUTES',
    name: 'menuItem.wheelOfFortune',
    image: <></>,
    tooltipId: 'sidebar-wheel-fo-fortune',
    tooltip: Tooltips.TOURNAMENTS
  },

  {
    path: 'VIP',
    name: 'VIP',
    image: <img src={star} alt="star" className="max-w-5" />,
    tooltipId: 'sidebar-vip',
    tooltip: Tooltips.VIP
  }
];

export const L = {
  NLD: {
    text: `${project.projectNameUppercase} is owned and operated by FGS SOFTWARE SOLUTIONS S.R.L., a company registered and established under the laws of Costa Rica. FGS SOFTWARE SOLUTIONS S.R.L. is regulated by the Government of Costa Rica. SOFTWARE SOLUTIONS S.R.L. registration number is 3-102-871832.`,
    logo: <img src={lnld} className="max-w-[65px] " alt="first license" />,
    getPageCodeFormat: (page?: string) => (page ? `${page}_jt` : undefined)
  },
  OTHERS: {
    text: `www.${project.projectName}.com is operated by Fair Game Software KFT (registration number 13-09-204926, registered under the laws of Hungary, registered address: 2161 Csomád, Kossuth Lajos út 79, is an agent of FairGame G.P. N.V ) which provides management, payment and support services related to the operation of the website. The operations of the website have been leased by the license holder FairGame G.P. N.V. (registration number 141938, address Abraham de Veerstraat 9, Curacao, with license number GLH-OCCHKTW0703032017 and regulated by the laws of Curacao and operates under the Master License of Gaming Services Provider, N.V. #365/JAZ as an Information Service Provider) to Fair Game Software KFT.`,
    logo: (
      <Link
        to="https://licensing.gaming-curacao.com/validator/?lh=21c0bec8198be1c2d52fe40bb0af4961"
        target="_blank">
        <License className="max-w-[100px]" />
      </Link>
    ),
    getPageCodeFormat: (page?: string) => page
  }
};

export const paymentsCards = [
  // {
  //   name: 'Visa',
  //   image: <Visa />
  // },
  // {
  //   name: 'Mastercard',
  //   image: <Mastercard />
  // },
  {
    name: 'Skrill',
    image: <Skrill />
  },
  {
    name: 'Neteller',
    image: <Neteller />
  },
  {
    name: 'Ezeewallet',
    image: <Ezeewallet />
  },
  {
    name: 'Neosurf',
    image: <Neosurf />
  },
  {
    name: 'Astropay',
    image: <Astropay />
  },
  {
    name: 'Flexepin',
    image: <Flexepin />
  },
  {
    name: 'Cashtocode',
    image: <Cashtocode />
  },
  {
    name: 'Interac',
    image: <Interac />
  },
  {
    name: 'Jeton',
    image: <Jeton />
  },
  {
    name: 'MB',
    image: <MB />
  },
  {
    name: 'EcoPayz',
    image: <EcoPayz />
  },
  {
    name: 'BankTransfer',
    image: <BankTransfer />
  },
  {
    name: 'Paysafe',
    image: <Paysafe />
  },
  {
    name: 'Ripple',
    image: <Ripple />
  },
  {
    name: 'Bitcoin',
    image: <Bitcoin />
  },
  {
    name: 'Ethereum',
    image: <Ethereum />
  },
  {
    name: 'Litecoin',
    image: <Litecoin />
  },
  {
    name: 'Tether',
    image: <Tether />
  }
  // {
  //   name: 'IdentityVerification',
  //   image: <IdentityVerification />
  // }
];

const arrayTransactions = [
  `${t('arrayTransactions.deposit')}`,
  `${t('arrayTransactions.withdraw')}`,
  `${t('arrayTransactions.bet')}`,
  `${t('arrayTransactions.win')}`,
  `${t('arrayTransactions.bonus')}`,
  `${t('arrayTransactions.jackpot')}`,
  `${t('arrayTransactions.changeBalanceInc')}`,
  `${t('arrayTransactions.changeBalanceDec')}`,
  `${t('arrayTransactions.referral')}`,
  `${t('arrayTransactions.convertBalance')}`,
  `${t('arrayTransactions.moneyPrize')}`,
  `${t('arrayTransactions.bonusTransaction')}`,
  `${t('arrayTransactions.cancelBonusFine')}`,
  `${t('arrayTransactions.refund')}`,
  `${t('arrayTransactions.rollbackBet')}`,
  `${t('arrayTransactions.betSport')}`,
  `${t('arrayTransactions.jackpotIncreasing')}`,
  `${t('arrayTransactions.levelBonus')}`
];

dayjs.extend(localeData);
dayjs.extend(utc);

export const transactionTypesOptions = arrayTransactions.map((element, index) => {
  return { name: element, id: String(index + 1) };
});

export const IconCurrency = {
  EUR: '€',
  USD: '$',
  RUB: '₽',
  FS: 'FS',
  JPY: '¥',
  CHF: 'CHF',
  AUD: 'AU$',
  CAD: 'C$',
  PLN: 'zł',
  NOK: 'kr',
  NZD: 'NZ$',
  DKK: 'kr',
  BRL: 'R$',
  SEK: 'kr',
  INR: '₹'
};

export const allCountriesData: Country[] = allCountries;

export const bonusTransactionsOptions = BONUS_TRANSACTION_TYPE.map((transaction, index) => ({
  id: `${index}`,
  name: t(`${transaction}`)
}));

export enum ScreenModes {
  Desktop,
  Mobile
}

export const SCREEN_MODE = ScreenModes.Mobile;

export const bonusQueue = [
  `${t('tableBonusQueue.name')}`,
  `${t('tableBonusQueue.amount')}`,
  `${t('tableBonusQueue.maxBet')}`,
  `${t('tableBonusQueue.wager')}`,
  `${t('tableBonusQueue.date')}`
];

export const sortType = [
  { id: 'amountAsc', name: 'sortType.amountUp', sort: 'amount', sortDir: 'asc' },
  { id: 'amountDesc', name: 'sortType.amountDown', sort: 'amount', sortDir: 'desc' },
  { id: 'dateAsc', name: 'sortType.dateUp', sort: 'date', sortDir: 'asc' },
  { id: 'dateDesc', name: 'sortType.amountUp', sort: 'date', sortDir: 'desc' }
];

export const categoryBadgeGame = {
  1: {
    id: 1,
    type: GameCardBannerType.NEW,
    title: 'categoryBadgeGame.new',
    style: 'game-1'
  },
  2: {
    id: 2,
    type: GameCardBannerType.TOP,
    title: 'categoryBadgeGame.top',
    style: 'background-10'
  }
};

export const vipData = [
  {
    code: 'level_1',
    blocks: [
      {
        title: 'VIP member status',
        content:
          'Enjoy extra privileges, so play your favorite games, improve your strategy and have fun!'
      },
      {
        title: '24-Hour Support Service',
        content: 'Top level service from experienced Account Managers.'
      }
    ]
  },
  {
    code: 'level_2',
    blocks: [
      {
        title: 'CashBack 10%',
        content: '10% cashback on your weekly play with 3X wagering.'
      },
      {
        title: '24-Hour Support Service',
        content: 'Top level service from experienced Account Managers.'
      },
      {
        title: 'Extra Activity rewards',
        content: 'Special events and prizes based on levels.'
      }
    ]
  },
  {
    code: 'level_3',
    blocks: [
      {
        title: 'Reward: 50% on a deposit',
        content: 'Bonus up to 300 euros with a wager 40 in bonus slots.'
      },
      {
        title: '24-Hour Support Service',
        content: 'Top level service from experienced Account Managers.'
      },
      {
        title: 'Extra Activity rewards',
        content: 'Special events and prizes based on levels.'
      }
    ]
  },
  {
    code: 'level_4',
    blocks: [
      {
        title: 'Reward: 100 Free Spins',
        content: '100 Free Spins with a bet of €/$0,20 per spin. Wager 40.'
      },
      {
        title: '24-Hour Support Service',
        content: 'Top level service from experienced Account Managers.'
      },
      {
        title: 'Extra Activity rewards',
        content: 'Special events and prizes based on levels.'
      }
    ]
  },
  {
    code: 'level_5',
    blocks: [
      {
        title: 'Personal Amazing Bonus',
        content: 'You can choose one bonus and activate it via support chat:'
      },
      {
        title: '24-Hour Support Service',
        content: 'Top level service from experienced Account Managers.'
      },
      {
        title: 'Extra Activity rewards',
        content: 'Special events and prizes based on levels.'
      }
    ]
  },
  {
    code: 'level_6',
    blocks: [
      {
        title: 'CashBack 11%',
        content: '11% cashback on your weekly play with 3X wagering.'
      },
      {
        title: 'Personal VIP service',
        content: 'We give our most active players a special personalized VIP service.'
      },
      {
        title: '24-Hour Support Service',
        content: 'Top level service from experienced Account Managers.'
      },
      {
        title: 'Extra Activity rewards',
        content: 'Special events and prizes based on levels.'
      }
    ]
  },
  {
    code: 'level_7',
    blocks: [
      {
        title: 'CashBack 12%',
        content: '12% cashback on your weekly play with 3X wagering.'
      },
      {
        title: 'Personal VIP service',
        content: 'We give our most active players a special personalized VIP service.'
      },
      {
        title: 'Individual Withdrawal Limits',
        content: 'Once you reach Level 7, contact your account manager for more information.'
      },
      {
        title: '24-Hour Support Service',
        content: 'Top level service from experienced Account Managers.'
      },
      {
        title: 'Extra Activity rewards',
        content: 'Special events and prizes based on levels.'
      }
    ]
  },
  {
    code: 'level_8',
    blocks: [
      {
        title: 'CashBack 13%',
        content: '13% cashback on your weekly play with 3X wagering.'
      },
      {
        title: 'Personal VIP service',
        content: 'We give our most active players a special personalized VIP service.'
      },
      {
        title: 'Individual Withdrawal Limits',
        content: 'Once you reach Level 8, contact your account manager for more information.'
      },
      {
        title: '24-Hour Support Service',
        content: 'Top level service from experienced Account Managers.'
      },
      {
        title: 'Extra Activity rewards',
        content: 'Special events and prizes based on levels.'
      }
    ]
  },
  {
    code: 'level_9',
    blocks: [
      { title: 'CashBack 15%', content: '15% cashback on your weekly play with 3X wagering.' },
      {
        title: 'Reward: 100 Free Spins',
        content: '100 Free Spins with a bet of €/$0,20 per spin. Wager 40.'
      },
      {
        title: 'Personal VIP service',
        content: 'We give our most active players a special personalized VIP service.'
      },
      {
        title: 'Individual Withdrawal Limits',
        content: 'Once you reach Level 9, contact your account manager for more information.'
      },
      {
        title: '24-Hour Support Service',
        content: 'Top level service from experienced Account Managers.'
      },
      {
        title: 'Extra Activity rewards',
        content: 'Special events and prizes based on levels.'
      }
    ]
  }
];

export const NLD_BANNED_PROVIDERS = {
  // eslint-disable-next-line quotes
  NetEnt: true,
  'Red Tiger': true,
  RelaxGaming: true,
  Yggdrasil: true,
  Wazdan: true,
  Microgaming: true,
  GameArt: true,
  Quickspin: true,
  Habanero: true,
  Thunderkick: true,
  '1x2 Gaming': true,
  Blueprint: true,
  '3 Oaks': true,
  Dlv: true,
  EGT: true,
  RedRake: true,
  ReelNRG: true,
  Ezugi: true,
  Evoplay: true,
  TrueLab: true,
  NetGame: true,
  iSoftBet: true,
  BigTimeGaming: true,
  Foxium: true,
  Fantasma: true,
  LightningBox: true,
  JustForTheWin: true,
  Ainsworth: true,
  Rabcat: true,
  'Real Dealer': true,
  Kalamba: true,
  ORYX: true,
  Spearhead: true,
  Gamomat: true,
  Givme: true,
  GoldenHero: true,
  GoldenRace: true,
  Hacksaw: true,
  IronDogStudio: true,
  LeapGaming: true,
  AugustGaming: true,
  Fazi: true,
  EAGaming: true,
  ThreeOaks: true,
  'Atomic Slot Lab': true,
  'Nolimit City': true,
  Swintt: true
};

export const BONUS_TYPE: Record<number, { name: string; content: string }> = {
  0: {
    name: 'Registration',
    content: 'bonusType.registration'
  },
  1: {
    name: 'RegistrationPromoCode',
    content: 'bonusType.registrationPromoCode'
  },
  2: {
    name: 'FirstAuthorization',
    content: 'bonusType.firstAuthorization'
  },
  3: {
    name: 'PromoCode',
    content: 'bonusType.promoCode'
  },
  4: {
    name: 'Birthday',
    content: 'bonusType.birthday'
  },
  5: {
    name: 'Deposits',
    content: 'bonusType.deposits'
  },
  6: {
    name: 'Periodic',
    content: 'bonusType.periodic'
  },
  7: {
    name: 'IncreaseWinnings',
    content: 'bonusType.increaseWinnings'
  },
  8: {
    name: 'ActivatedByLink',
    content: 'bonusType.activatedByLink'
  }
};

export const contentGamesPageCodes = {
  megaways: 'megaways',
  'fruits-games': 'fruit',
  books: 'book',
  dropwins: 'drops_win',
  aviator: 'aviator'
};

export const paginationDots = '...';
export const siblingCount = 1;
export const totalPageNumbers = siblingCount + 5;
export const leftItemCount = 4;
export const rightItemCount = 4;

export const arrayFromRange = (start: number, end: number): number[] => {
  const length = end - start + 1;
  return Array.from({ length }, (_, idx) => idx + start);
};

export const isPwa = window.matchMedia('(display-mode: standalone)').matches;

// Должен точно дублировать текущий tailwind config
export const BP = {
  // MOBILE
  M_XS: 320,
  M_SM: 360,
  M_MD: 375,
  M_LG: 412,

  // TABLET
  T_XS: 568,
  T_SM: 640,
  T_MD: 768,

  // DEKSTOP
  XGA: 1024,
  HD: 1280,
  QHD: 1440,
  FULL_HD: 1920,
  WQHD: 2560
};

export const PROVIDER_ID_SEARCH_PARAM = 'providerId';

export const USER_TOURNAMENT_QUANTITATIVE_TASK_TYPES = [2, 4, 6];

export const PASSWORD_VALIDATION_SYMBOLS = /^[0-9a-zA-Z#$._@&!;%:?*()^-]+$/;
export const PASSWORD_VALIDATION_LENGTH = /^.{5,64}$/;
export const MAX_PASSWORD_LENGTH = 64;
export const MAX_EMAIL_LENGTH = 256;

export const FIFTEEN_SECONDS = 15000;
export const FIVE_SECONDS = 5000;

export const MIN_USER_DEPOSIT_VALUE = 100;
export const ONE_MINUTE_MS = 60000;
export const THREE_SECONDS = 3000;

export const CACHE_TIME_2000 = {
  gcTime: 2000,
  staleTime: 2000
};
